module.exports = __webpack_public_path__ + "static/img/workbanner.53f1085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/workbanner.jpg
// module id = u4UH
// module chunks = 10